import { useQuery } from "@apollo/client";

import { GqlPlannerV2VisitGetAllParams } from "~/__generated__";
import useCacheFilterOptions from "~/modules/app/hooks/useCacheFilterOptions";

import { VisitListScreen_GetAllDocument } from "../queries.generated";

export function useVisitListScreen_GetAll(params: GqlPlannerV2VisitGetAllParams) {
    const { data, loading, error } = useQuery(VisitListScreen_GetAllDocument, {
        variables: { params },
        fetchPolicy: "cache-and-network",
    });

    const queryInfo = data?.plannerV2VisitGetAll.queryInfo;
    const [filterOptions, total] = useCacheFilterOptions(queryInfo?.filterOptions, queryInfo?.paginationOption.total);

    return {
        loading,
        error,
        total,
        filterOptions,
        data: data?.plannerV2VisitGetAll.data,
    };
}
